var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1693 25.2807L21.0015 31.1403L15.1693 37M33.2724 28.943C37.976 26.7368 41.0029 23.2913 41 19.421C41.002 14.914 36.9009 10.9854 30.8256 8.91664M20.3264 31.4699C9.59371 31.2575 1.00146 25.9443 1 19.421C1 14.6493 5.59771 10.5259 12.2679 8.57159M21.5467 21.7168C21.1851 21.7168 20.8297 21.622 20.5158 21.4418L13.2989 17.2901C12.6607 16.9234 12.2679 16.246 12.2679 15.5116V7.20623C12.2679 6.47286 12.6607 5.79438 13.2989 5.42666L20.5158 1.27501C20.8297 1.09479 21.1851 1 21.5467 1C21.9084 1 22.2637 1.09479 22.5777 1.27501L29.7946 5.42666C30.1072 5.60555 30.3671 5.86426 30.5482 6.17659C30.7292 6.48891 30.8249 6.84376 30.8256 7.2052V15.5106C30.8256 16.2439 30.4327 16.9224 29.7946 17.2901L22.5777 21.4418C22.2637 21.622 21.9084 21.7168 21.5467 21.7168ZM21.5467 21.7168V11.3589M21.5467 11.3589L30.5472 6.13828M21.5467 11.3589L12.5463 6.13828",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbit);
export default __webpack_public_path__ + "static/media/orbit.8376b77e350e9cfe05712bf0464dbd29.svg";
export { ForwardRef as ReactComponent };